/**
 * CodeMirror 6 JSON editor with syntax highlighting, folding and live linting.
 *
 * The `jsonParseLinter` surfaces parse errors inline (squiggles + gutter markers)
 * so the user sees exactly where invalid JSON is, unlike a plain textarea.
 */

import { json, jsonParseLinter } from "@codemirror/lang-json";
import { linter, lintGutter } from "@codemirror/lint";
import CodeMirror from "@uiw/react-codemirror";

const EXTENSIONS = [json(), linter(jsonParseLinter()), lintGutter()];

interface CodeEditorProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

const CodeEditor = ({ value, onChange, readOnly = false }: CodeEditorProps) => (
  <CodeMirror
    value={value}
    onChange={onChange}
    readOnly={readOnly}
    height="100%"
    theme="light"
    extensions={EXTENSIONS}
    className="h-full text-xs"
    basicSetup={{
      lineNumbers: true,
      foldGutter: true,
      highlightActiveLine: true,
      bracketMatching: true,
      autocompletion: true,
      highlightSelectionMatches: true,
    }}
  />
);

export default CodeEditor;
